/* requires:
polyfill.js
*/

if (document.querySelector('.copyright-year')) {
  document.querySelector('.copyright-year').innerHTML = new Date().getFullYear();
}

// Try to keep the rediredctor API awake and running
// Put this back once site goes static off old server
// by calling it if 5 minutes has passed since the last call
(function () {
  const apiUrl = '/api/wake-up/';
  const dateNow = Date.now();
  const lastApiCall = sessionStorage.getItem('lastApiCall') ? Number(sessionStorage.getItem('lastApiCall')) : null;
  const wakeApi = async () => {
    try {
      const response = await fetch(apiUrl);
      if (response.ok) {
        const data = await response.text();
        console.log('API:', data);
        // store the current time in sessionStorage
        sessionStorage.setItem('lastApiCall', dateNow);
      } else {
        console.error('Error:', response.status, response.statusText);
      }
    } catch (error) {
      console.error('Request failed:', error.message);
    }
  };
  // if the last API call was more than 5 minutes ago, call the API
  if (!window.location.hostname.includes('localhost') && (!lastApiCall || lastApiCall + 300000 < dateNow)) {
    wakeApi();
  }
})();
